import PaymentHistory from '@/entities/PaymentHistory.js';
import api from '@/services/Api';

export default {
  get(id) {
    return api().get('/payment-history/' + id)
      .then(resp => new PaymentHistory(resp));
  },

  getList({ page, limit }) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();

    return api().get('/payment-histories?' + query)
      .then(resp => resp.map(i => new PaymentHistory(i)));
  },

  generatePaymentIntent(id) {
    return api().post('/payment-history/' + id + '/generate-payment-intent');
  },

  downloadInvoice(id, filename) {
    return api().get('/payment-history/' + id + '/download-invoice', { responseType: 'blob' })
      .then(response => {
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);

        return response;
      });
  },
};
